import { useEffect, useMemo, useState } from "react"
import { useFilter } from "../../../context/FIlterContext";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import _ from "underscore";
import { callautopopulate } from "../../../services/callautopop";

export const useTimeSpentTask = ({ projectOpts }) => {
    const { projectFilter, setProjectFilter } = useFilter();
    const [chartData, setChartData] = useState({});
    const [filter, setFilter] = useState({ project_ids: [], isChange: false })
    const [loader, setLoader] = useState(false);
    const [categoryOptions, setCategoryOption] = useState([]);

    useEffect(() => {
        callautopopulate("category_type").then((res) => {
            setCategoryOption(res?.category_type);
            setFilter({ project_ids: [], categoryType: _.find(res?.category_type, { category_name: "clients" }) })
        })
    }, [])

    useEffect(() => {
        if (projectFilter?.apiCall) {
            getTaskTimeSpentData();
        }
    }, [projectFilter?.apiCall]);

    const getTaskTimeSpentData = async () => {
        const projectsId = _.pluck(projectOpts, 'project_id')?.toString()
        try {
            setLoader(true)
            const payload = {
                "client_id": projectFilter?.client_id?.client_id || 0,
                "project_ids": filter?.categoryType?.category_name === "projects" && projectFilter?.project_ids?.length === 0 ? projectsId : _.pluck(projectFilter?.project_ids, 'project_id')?.toString(),
                "lead_user_code": projectFilter?.lead_user_code?.user_code || 0,
                "request_user_code": projectFilter?.request_user_code || 0,
                "project_module_ids": _.pluck(projectFilter?.project_module_ids, 'option_id')?.toString(),
                "feature_ids": _.pluck(projectFilter.feature_ids, 'issue_id')?.toString(),
                "issue_key": projectFilter?.issue_id,
                "category_type": filter?.categoryType?.category_name || "clients"
            }
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTTIMEINSTATUSSUMMARY'), payload)
            if (res?.status === 200) {
                let data = res?.body?.data?.project_time_in_status_summary;
                const categoryIdToClientName = {};
                data.forEach(item => {
                    categoryIdToClientName[item.category_id] = item.category_name;
                });
                const categoryIds = [...new Set(data.map(item => item.category_id))];
                const clientNames = categoryIds.map(catId => categoryIdToClientName[catId]);
                const statusNames = [...new Set(data.map(item => item.status_name))];
                const categoryStatusMap = {};
                categoryIds.forEach(catId => {
                    categoryStatusMap[catId] = {};
                    statusNames.forEach(status => {
                        categoryStatusMap[catId][status] = 0;
                    });
                });

                data.forEach(item => {
                    categoryStatusMap[item.category_id][item.status_name] = Number(item.total_timespent_hours.toFixed(2));
                });

                const series = statusNames.map(status => ({
                    name: status,
                    data: categoryIds.map(catId => categoryStatusMap[catId][status])
                }));
                const yValues = series
                    ?.flatMap(s => s.data)
                    .filter(val => typeof val === 'number');

                const min = Math.min(...yValues);
                const max = Math.max(...yValues);
                const tickInterval = Math.ceil(((max - min) / 4));
                setChartData({ xAxis: clientNames, data: series, min, max, tickInterval });
            }
            setFilter((prev) => ({ ...prev, isChange: false }))
            setLoader(false)
        } catch (error) {
            setLoader(false)
            setProjectFilter((prev) => ({ ...prev, apiCall: false }))
            console.error('Error :', error);
        }
    }
    return useMemo(() => ({
        chartData, loader, getTaskTimeSpentData, filter, setFilter, categoryOptions
    }), [chartData, loader, getTaskTimeSpentData, filter, setFilter, categoryOptions]);
}